import { useId } from "react";
import { cn } from "@/lib/cn";

export interface OpcionCheckList {
  valor: string;
  etiqueta: string;
  detalle?: string;
  deshabilitado?: boolean;
}

export interface CheckListProps {
  etiqueta: string;
  opciones: OpcionCheckList[];
  valores: string[];
  onCambio: (valores: string[]) => void;
  error?: string | null;
  ayuda?: string;
  vacio?: string;
  className?: string;
}

/** Lista de casillas para elegir varias opciones (unidades de una venta). Accesible: `group` con nombre y un `checkbox` por opción. */
export function CheckList({ etiqueta, opciones, valores, onCambio, error, ayuda, vacio = "No hay opciones", className }: CheckListProps) {
  const id = useId();
  const alternar = (valor: string, marcado: boolean) => onCambio(marcado ? [...valores, valor] : valores.filter((v) => v !== valor));
  const descripcion = error ? `${id}-error` : ayuda ? `${id}-ayuda` : undefined;
  return (
    <fieldset className={cn("flex flex-col gap-1.5", className)} aria-describedby={descripcion}>
      <legend className="text-chico font-medium text-texto">{etiqueta}</legend>
      <div className={cn("max-h-56 overflow-y-auto rounded-control border border-borde-fuerte bg-superficie", error && "border-peligro")}>
        {opciones.length === 0 && <p className="px-3 py-2 text-chico text-texto-suave">{vacio}</p>}
        {opciones.map((o) => (
          <label key={o.valor} className={cn("flex cursor-pointer items-center gap-3 px-3 py-2 hover:bg-superficie-2", o.deshabilitado && "cursor-not-allowed opacity-60")}>
            <input
              type="checkbox"
              className="size-4 accent-primario"
              checked={valores.includes(o.valor)}
              disabled={o.deshabilitado}
              onChange={(e) => alternar(o.valor, e.target.checked)}
            />
            <span className="flex-1">{o.etiqueta}</span>
            {o.detalle && <span className="text-chico text-texto-suave">{o.detalle}</span>}
          </label>
        ))}
      </div>
      {error ? (
        <p id={`${id}-error`} className="text-chico text-peligro">{error}</p>
      ) : ayuda ? (
        <p id={`${id}-ayuda`} className="text-chico text-texto-suave">{ayuda}</p>
      ) : null}
    </fieldset>
  );
}
